import React, { useEffect, useState } from 'react';
import HeadTitle from '../../components/HeadTitle';
import SupportRequestTable from '../../components/support/supportRequest-table';
import { useSelector } from 'react-redux';
import { fetchSupportData } from '../../api/support';

const SupportTickets = () => {
  const { filter } = useSelector((state) => state);
  const [userData, setUserData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(25);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("")

  const [components] = useState([
    {
      id: 1,
      imageSrc: '/assets/images/admin-panel/verification/verify.svg',
      text: 'Support Tickets ',
      description: '',
      // 'informed about platform updates, upcoming features, policy changes, events, and other important information',
    },
  ]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const data = await fetchSupportData(
        setUserData,
        currentPage,
        pageLimit,
        0,
        filter
      );
      setTotalUsers(data.total);
      setTotalPages(data.totalPages);
    } catch (error) {
      console.error('Error while loading real-time data', error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    fetchData();
  }, [filter, currentPage]);

  return (
    <div>
      {/* Dynamically Render Components */}
      {components.map((component) => (
        <HeadTitle
          key={component.id}
          imageSrc={component.imageSrc}
          text={component.text}
          description={component.description}
        />
      ))}

      {/* <SearchFilter /> */}

      {/* <HeaderStats
        stats={stats}
        data={userData}
        onFilterChange={handleFilterChange}
      /> */}

      <SupportRequestTable
        data={userData}
        totalPages={totalPages}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
        itemsPerPage={itemsPerPage}
        loading={loading}
        fetchData={fetchData}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
    </div>
  );
};

export default SupportTickets;
